module.exports = __webpack_public_path__ + "static/media/10000d_p.b933cfc6.jpg";